import { defineStore } from 'pinia';
import { IntegrationSchoolDayService } from '@/services';

export default defineStore('TenantIntegrationSISSchoolDayStore', {
  actions: {
    async sync(tenantId: number, id: number) {
      const response = await IntegrationSchoolDayService.sync(tenantId, id);
      const message = response.data.success;

      this.doToast(message.message, message.title);
    },
  },
});
